<template>
   <div>
      <div class="form-group _margin-bottom-30">
         <div class="col-xs-12 _margin-bottom-20" v-if="isFuse">
            <form-label id="switchAfterCoolingOfPeriod">Faster Switching</form-label>
            <p class="_margin-top-0 _margin-bottom-0">
               I understand that the switch to Fuse Energy will go ahead as soon as possible. Should I change my mind
               within the 14 day cooling off period I can do so without incurring any early exit fees and I agree to pay
               for the energy used whilst on supply with Fuse Energy
            </p>
            <p class="_margin-bottom-0">
               Your application will be sent to Fuse Energy, who will get in touch to confirm your details. Fuse Energy
               will switch you over in approximately 5 working days and will contact you if any further details are
               required. Fuse Energy will send your Welcome Pack by email which will contain your confirmation of
               contact, tariff information and terms and conditions.
            </p>
         </div>

         <template v-else>
            <div class="col-xs-12 _margin-bottom-20">
               <form-label id="switchAfterCoolingOfPeriod">Faster Switching</form-label><br />
               <small>Select one:</small>
               <radio :value="false" id="asap" v-model="terms.switchAfterCoolingOfPeriod"
                  :error="v.switchAfterCoolingOfPeriod.$error">
                  I want to switch to {{ switchPlan.supplierName }} as soon as possible and consent to being billed for the
                  services provided after my switch has been processed and pay for any usage of energy consumed should I
                  change my mind during the 14 day *cooling off period.
               </radio>

               <radio :value="true" id="14days" v-model="terms.switchAfterCoolingOfPeriod"
                  :error="v.switchAfterCoolingOfPeriod.$error">
                  Please delay my switch by two weeks until after the 14 day *cooling-off period is over.
               </radio>
            </div>

            <div class="col-xs-12 _margin-bottom-20">
               <small>*The cooling-off period commences the day after you enter a contract with {{ switchPlan.supplierName
                  }} for your new energy supply. The cooling off period will last for 14 days. {{ switchPlan.supplierName
                  }} will inform you when your new supply for energy will start upon processing this switch</small>
            </div>
         </template>

         <div class="col-xs-12">
            <form-label id="gasSmartMeterInstalled">Smart Meter</form-label><br />
            <small v-if="switchPlan.fuelTitle == 'Gas & Electricity'">Select at least one:</small>
         </div>

         <div class="col-xs-12"
            :class="{ 'col-sm-4': switchPlan.fuelTitle == 'Gas & Electricity', 'col-sm-6': switchPlan.fuelTitle !== 'Gas & Electricity' }"
            v-if="switchPlan.fuelTitle != 'Electricity'">
            <checkbox id="gasSmartMeterInstalled" v-model="terms.gasSmartMeterInstalled"
               :error="v.neitherSmartMeterInstalled.$error" @change="onChangeSmartMeterInstalled">
               Yes, I have a smart gas meter
            </checkbox>
         </div>

         <div class="col-xs-12"
            :class="{ 'col-sm-5': switchPlan.fuelTitle == 'Gas & Electricity', 'col-sm-6': switchPlan.fuelTitle !== 'Gas & Electricity' }"
            v-if="switchPlan.fuelTitle != 'Gas'">
            <checkbox id="electricitySmartMeterInstalled" v-model="terms.electricitySmartMeterInstalled"
               :error="v.neitherSmartMeterInstalled.$error" @change="onChangeSmartMeterInstalled">
               Yes, I have a smart electricity meter
            </checkbox>
         </div>

         <div class="col-xs-12 col-sm-3" v-if="switchPlan.fuelTitle == 'Gas & Electricity'">
            <checkbox id="neitherSmartMeterInstalled" v-model="terms.neitherSmartMeterInstalled"
               :error="v.neitherSmartMeterInstalled.$error" @change="onChangeNeitherInstalled">
               Neither
            </checkbox>
         </div>
      </div>
      <div class="form-group _margin-bottom-20" v-show="switchPlan.payMethod == 'PrePaymentMeter'">
         <div class="col-sm-8">
            <form-label id="prePaymentMeter">Pre Payment Meter Type</form-label>
            <validation-messages label="Pre Payment Meter Type" :$v="v.prePaymentMeterId">
               <select-list id="prePaymentMeter" v-model="terms.prePaymentMeterId" value-key="id" :list="prepaymentList"
                  :error="v.prePaymentMeterId.$error" />
            </validation-messages>
         </div>
      </div>
      <uiv-alert type="info" v-if="terms.gasSmartMeterInstalled || terms.electricitySmartMeterInstalled">
         <div class="_margin-bottom-10">
            <b>If you have a smart meter you may lose some or all of its SMART functionality .e.g.</b>
         </div>

         - Automated meter reading<br />
         - Energy display or monitor
      </uiv-alert>

      <div class="form-group" v-if="terms.gasSmartMeterInstalled || terms.electricitySmartMeterInstalled">
         <div class="col-md-10">
            <validation-messages label="Agreement" :$v="v.agreeSmartMeterConditions">
               <checkbox id="agreeSmartMeterConditions" v-model="terms.agreeSmartMeterConditions"
                  :error="v.agreeSmartMeterConditions.$error"
                  @change="terms.agreeSmartMeterConditions = terms.agreeSmartMeterConditions ? true : null">
                  Yes, I can confirm that I understand the loss of this functionality
                  and am happy to continue.
               </checkbox>
            </validation-messages>
         </div>
      </div>

      <uiv-alert type="danger" v-if="v.agreeSmartMeterConditions.$error">
         <b>Smart Meter Terms & Conditions</b><br />

         As you have not agreed {{ switchPlan.supplierName }}'s smart meter terms
         and conditions, this switch cannot proceed. However, you can still switch
         to other supplier from results page by pressing back button.
      </uiv-alert>

      <div class="form-group _margin-bottom-40" v-if="!isFuse">
         <div class="col-md-10">
            <form-label id="reminder_yes">
               Can {{ switchPlan.supplierName }} contract you via email and/or by
               mobile phone in order to send you reminders keeping you up-to-date
               with your account?
            </form-label>

            <div class="row">
               <div class="col-xs-6 col-sm-4">
                  <checkbox v-model="terms.supplierMaySendRemindersAndUpdatesViaEmailAboutAccount">
                     Email
                  </checkbox>
               </div>

               <div class="col-xs-6 col-sm-4">
                  <checkbox v-model="terms.supplierMaySendRemindersAndUpdatesViaTelephoneAboutAccount">
                     Mobile
                  </checkbox>
               </div>
            </div>
         </div>
      </div>

      <!-- Marketing channel checkboxes removed for Fuse white-label journey -->

      <div class="form-group _margin-bottom-30" v-if="isFuse">
         <div class="col-md-10">
            <form-label id="fuseMarketingConsent">
               Would you like to receive marketing communications from Fuse Energy, including our latest offers,
               products and news?
            </form-label>
            <validation-messages
               label="Marketing communications"
               :$v="v.supplierMaySendRemindersAndUpdatesViaEmailAboutAccount">
               <div :class="{ 'has-error': v.supplierMaySendRemindersAndUpdatesViaEmailAboutAccount.$error }">
                  <radio :value="true" id="fuseMarketingConsent_yes" inline style="margin-right: 10px;"
                     v-model="terms.supplierMaySendRemindersAndUpdatesViaEmailAboutAccount"
                     :error="v.supplierMaySendRemindersAndUpdatesViaEmailAboutAccount.$error">
                     Yes
                  </radio>
                  <radio :value="false" id="fuseMarketingConsent_no" inline
                     v-model="terms.supplierMaySendRemindersAndUpdatesViaEmailAboutAccount"
                     :error="v.supplierMaySendRemindersAndUpdatesViaEmailAboutAccount.$error">
                     No
                  </radio>
               </div>
            </validation-messages>
         </div>
      </div>

      <div class="form-group _margin-bottom-20" v-else>
         <div class="col-md-10">
            <checkbox id="supplierMaySendImportantAccountChangesViaEmail"
               v-model="terms.supplierMaySendImportantAccountChangesViaEmail">
               Can {{ switchPlan.supplierName }} contact you via email in order to
               send you details about important changes to your account; such as
               direct debit, price changes and contract information?
            </checkbox>
         </div>
      </div>

      <div class="form-group _margin-bottom-20" v-if="!isFuse">
         <div class="col-sm-12">
            <checkbox id="hasMedicalCondition" v-model="terms.hasMedicalConditionOrIndividualRequirement"
               @change="onChangeSpecialNeeds">
               I have a particular medical condition or individual requirement.<br />
               <small v-if="terms.hasMedicalConditionOrIndividualRequirement">Any information provided will be passed
                  onto your new Supplier, who may subsequently request further information from you.</small>
            </checkbox>
         </div>

         <div class="col-sm-8 _margin-top-20" v-if="terms.hasMedicalConditionOrIndividualRequirement">
            <form-label id="condition">Conditions</form-label>
            <validation-messages label="Condition" :$v="v.specialNeedsId">
               <select-list id="condition" v-model="terms.specialNeedsId" value-key="id" :list="specialNeedsList"
                  :error="v.specialNeedsId.$error" />
            </validation-messages>
         </div>
      </div>

      <div class="form-group _margin-bottom-20">
         <div class="col-md-10">
            <validation-messages label="Terms & Conditions Agreement" :$v="v.suppliersTermsAndConditionsAreAccepted">
               <checkbox id="termsAndConditions" v-model="terms.suppliersTermsAndConditionsAreAccepted"
                  :error="v.suppliersTermsAndConditionsAreAccepted.$error"
                  @change="terms.suppliersTermsAndConditionsAreAccepted = terms.suppliersTermsAndConditionsAreAccepted ? true : null">
                  Yes, I accept the energy supplier
                  <a target="_blank" :href="isFuse ? fuseTermsUrl : switchPlan.supplierTosUrl">terms and conditions</a>
               </checkbox>
            </validation-messages>
         </div>
      </div>
   </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
   name: 'SupplierSpecificTermsDefault',
   props: {
      v: Object
   },
   data() {
      return {
         fuseTermsUrl: 'https://www.fuseenergy.com/legal/energy-supply-terms-and-conditions'
      };
   },
   mounted() {
      // Keep removed channel flags off in the API payload
      this.terms.supplierMaySendUpdatesThatMayBeOfInterestViaDayPhone = false;
      this.terms.supplierMaySendUpdatesThatMayBeOfInterestViaEmail = false;
      this.terms.supplierMaySendUpdatesThatMayBeOfInterestViaEveningPhone = false;
      this.terms.supplierMaySendUpdatesThatMayBeOfInterestViaFaceToFace = false;
      this.terms.supplierMaySendUpdatesThatMayBeOfInterestViaMobilePhone = false;
      this.terms.supplierMaySendUpdatesThatMayBeOfInterestViaPost = false;
      this.terms.supplierMaySendUpdatesThatMayBeOfInterestViaSms = false;
      if (this.isFuse) {
         this.terms.switchAfterCoolingOfPeriod = false;
         this.terms.supplierMaySendRemindersAndUpdatesViaEmailAboutAccount = null;
         this.terms.supplierMaySendImportantAccountChangesViaEmail = false;
         this.terms.supplierMaySendRemindersAndUpdatesViaTelephoneAboutAccount = false;
         this.terms.hasMedicalConditionOrIndividualRequirement = false;
         this.terms.specialNeedsId = null;
      }
   },
   computed: {
      ...mapState({
         switchPlan: ({ personal_details_switch_plan }) => personal_details_switch_plan,
         terms: ({ personal_details_terms }) => personal_details_terms,
         specialNeedsList: ({ lookups }) => lookups.specialNeeds,
         prepaymentList: ({ lookups }) => lookups.prepayments
      }),
      isFuse() {
         return /fuse/i.test((this.switchPlan && this.switchPlan.supplierName) || '');
      }
   },
   methods: {
      onChangeSpecialNeeds() {
         if (this.terms.hasMedicalConditionOrIndividualRequirement) {
            this.$store.dispatch('lookups/getSpecialNeedsList');
         } else {
            this.terms.specialNeedsId = null;
         }
      },
      onChangeSmartMeterInstalled() {
         if (this.terms.gasSmartMeterInstalled || this.terms.electricitySmartMeterInstalled) {
            this.terms.agreeSmartMeterConditions = null;
            this.terms.neitherSmartMeterInstalled = false;
         } else {
            this.terms.agreeSmartMeterConditions = false;
            this.terms.neitherSmartMeterInstalled = null;
         }
      },
      onChangeNeitherInstalled(value) {
         this.terms.neitherSmartMeterInstalled = value || null;
         this.terms.gasSmartMeterInstalled = false;
         this.terms.electricitySmartMeterInstalled = false;
         this.terms.agreeSmartMeterConditions = false;
      }
   }
};
</script>

<style lang="scss"></style>
